module.exports = __webpack_public_path__ + "static/media/ChevronRight.940bb0eb.svg";